var _style, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 790 702",
    style: {
      enableBackground: "new 0 0 790 702"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6E6E6;}\r\n\t.st1{opacity:0.11;fill:#E1FFFF;enable-background:new    ;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FFB8B8;}\r\n\t.st4{fill:#722ED1;}\r\n\t.st5{fill:#3F3D56;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M678.9,580c-13.3,39-30.5,78-52.4,115.1c-0.5,0.8-1,1.7-1.5,2.5l-54.4-17.2c0.3-0.8,0.7-1.7,1-2.6 c21.9-56.7,154.2-402.2,148.3-470.4C720.6,213,741.3,397.5,678.9,580z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637,698.4c-0.7,0.8-1.5,1.5-2.3,2.2l-40.8-12.9c0.6-0.7,1.2-1.5,1.9-2.3c12.1-14.8,48-58.9,83.1-105.4 c37.7-49.9,74.4-102.5,79.5-124.1C757.4,460.8,725.3,610.4,637,698.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.4,123.1C657.4,123.1,657.3,123.1,657.4,123.1V35.7c0-19.7-16-35.7-35.7-35.7H347.9 c-19.7,0-35.7,16-35.7,35.7v44.8c-1.6,0-2.8,1.3-2.8,2.9v22.2c0,1.6,1.3,2.9,2.8,2.9v23.3h-0.1c-1.6,0-2.9,1.3-2.9,2.9l0,0v42.9 c0,1.6,1.3,2.9,2.9,2.9l0,0h0.1v17.1l0,0c-1.6,0-2.9,1.3-2.9,2.9l0,0v43.3c0,1.6,1.3,2.9,2.9,2.9l0,0l0,0v419 c0,19.7,16,35.7,35.7,35.7h273.7c19.7,0,35.7-16,35.7-35.7V208.1l0,0c2.8,0,5.2-2.3,5.2-5.2l0,0v-74.7 C662.5,125.4,660.2,123.1,657.4,123.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M636,45.7v610c0,15.1-12.3,27.4-27.4,27.4H360.9c-15.1,0-27.4-12.3-27.4-27.4v-610c0-15.1,12.3-27.4,27.4-27.4 H398v4.8c0,12.5,10.1,22.6,22.6,22.6h126c12.4,0,22.5-10.1,22.5-22.6v-4.8h39.5C623.7,18.3,636,30.6,636,45.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.4,342.3c-5.5-2.1-11.8,0.6-13.9,6.1c-0.2,0.6-0.4,1.2-0.5,1.8l-88.3,48l15.5,17.5l82-52.6 c5.9,0.8,11.3-3.4,12.1-9.3C241.9,348.8,239.1,344.1,234.4,342.3L234.4,342.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "211.9,687.6 222.9,680.4 200.7,634.6 184.5,645.1 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250.7,676.9l-34.6,22.4l0,0l-8.6-13.4l0,0l21.7-14c7.1-4.6,16.6-2.6,21.2,4.5l0,0L250.7,676.9L250.7,676.9 L250.7,676.9z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "88.5,689.2 101.6,689.2 107.8,638.7 88.5,638.7 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M126.9,701.4H85.7l0,0v-15.9l0,0h25.9c8.5,0,15.3,6.9,15.3,15.3l0,0V701.4L126.9,701.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389,99h-27c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h27c1.4,0,2.5,1.1,2.5,2.5S390.4,99,389,99z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389,106h-27c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h27c1.4,0,2.5,1.1,2.5,2.5S390.4,106,389,106z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389,113h-27c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h27c1.4,0,2.5,1.1,2.5,2.5S390.4,113,389,113z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M598.3,106h-0.9l-0.3-0.3c1.1-1.4,1.8-3.1,1.8-4.9c0-4.1-3.4-7.4-7.5-7.4s-7.4,3.4-7.4,7.5s3.4,7.4,7.5,7.4 c1.8,0,3.5-0.6,4.9-1.8l0.3,0.3v0.9l5.7,5.8l1.7-1.7L598.3,106z M591.4,106c-2.9,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2 l0,0l0,0C596.6,103.7,594.3,106,591.4,106L591.4,106L591.4,106L591.4,106z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444,191h-48.5c-6.1,0-11-4.9-11-11s4.9-11,11-11H444c6.1,0,11,4.9,11,11S450.1,191,444,191z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.5,215h-202c-3.3,0-6-2.7-6-6s2.7-6,6-6h202c3.3,0,6,2.7,6,6S595.8,215,592.5,215z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.7,239h-74.2c-3.3,0-6-2.7-6-6s2.7-6,6-6h74.2c3.3,0,6,2.7,6,6S468,239,464.7,239z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444,457h-48.5c-6.1,0-11-4.9-11-11s4.9-11,11-11H444c6.1,0,11,4.9,11,11S450.1,457,444,457z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.5,481h-202c-3.3,0-6-2.7-6-6s2.7-6,6-6h202c3.3,0,6,2.7,6,6S595.8,481,592.5,481z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.7,505h-74.2c-3.3,0-6-2.7-6-6s2.7-6,6-6h74.2c3.3,0,6,2.7,6,6S468,505,464.7,505z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444,580h-48.5c-6.1,0-11-4.9-11-11s4.9-11,11-11H444c6.1,0,11,4.9,11,11S450.1,580,444,580z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.5,604h-202c-3.3,0-6-2.7-6-6s2.7-6,6-6h202c3.3,0,6,2.7,6,6S595.8,604,592.5,604z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.7,628h-74.2c-3.3,0-6-2.7-6-6s2.7-6,6-6h74.2c3.3,0,6,2.7,6,6S468,628,464.7,628z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M621,394.5H235c-4.7,0-8.5-3.8-8.5-8.5V281c0-4.7,3.8-8.5,8.5-8.5h386c4.7,0,8.5,3.8,8.5,8.5v105 C629.5,390.7,625.7,394.5,621,394.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.2,519.4C99.9,545.3,80.4,660,82.6,660l28.1-0.2c1-1.9,13.9-63.8,17.9-73.7c5.6-13.8,11.3-27.7,13.5-42.5 c2.1-13.8,1.1-27.9-0.3-41.8c0.2-1.4-0.8-2.8-2.2-3c-0.3,0-0.6,0-0.8,0l-37.6-1.9c-7.8-0.4-9.6-2.1-8.4,5.5 C93.5,508.1,95.4,513.7,96.2,519.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.6,456.5c-7.6,11-15.7,23.7-13.1,36.8c1.9,10,9.5,17.8,16.7,25c28.7,28.9,85.4,156.2,85.4,156.2 c27.3-17.5-0.7,0.5,27.1-18c-2.5-0.2-58.4-201.1-63-201.4C138,453.9,121.9,452.1,103.6,456.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.9,351.8c-3.9-3.5-31.2-14.2-31.2-14.2c-0.5-0.1-1-0.1-1.5,0c-1.6,0.4-2.3,2.3-1.9,3.9s-2.4,27.2-3.1,38.9 c-1.2,20.4,10.8,66.5,10.7,67.9c-0.4,5-2.6,9.7-6.2,13.3c0.9,1.2,60.3,3.5,64.3,4.9c0.8-1-4.6-74.2-4.8-78.3 C159.7,381.9,139,356.5,133.9,351.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.6,510.6c5.3-2.6,7.5-9.1,4.8-14.4c-0.3-0.6-0.6-1.1-1-1.6l25-138.5L97,355.8l-17.4,137 c-4.5,3.9-5.1,10.7-1.2,15.2C81.7,511.7,87.1,512.8,91.6,510.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.4,366.3c-1,0.1-1.9-0.2-2.8-0.7c-1.4-1.2,10-19.4,12.2-19.7c7.3-0.8,14.8-1.1,21.9,0.9 c7.1,2,13.7,6.5,16.9,13.1c1.3,2.8-8.3,16.6-12.6,14.6C121.7,372,98.2,366.4,91.4,366.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 117.1,
    cy: 309.9,
    r: 26.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.3,353.3c12,1.3,22.8-7.5,24.1-19.5c0.3-3.1,0-6.2-1-9.2c-1-3.1-2.8-6-3.7-9.2s-1-6.9,1.1-9.5 c4.1-5,12.1-1.8,18.5-2.8c6.8-1.1,12-7.6,12.6-14.5s-3-13.7-8.4-18.1s-12.2-6.5-19.1-7.2C87,260.5,61.8,281.2,59,309.6 c-0.8,8.2,0.4,16.5,3.4,24.2c2.9,7.2,7.6,13.9,14.2,17.8s15.4,4.7,22.1,0.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.3,320.5h-67.1c-4.3,0-7.7-4.9-7.7-11s3.5-11,7.7-11h67.1c4.3,0,7.7,4.9,7.7,11S376.5,320.5,372.3,320.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.5,344.5h-249c-3.3,0-6-2.7-6-6s2.7-6,6-6l0,0h249c3.3,0,6,2.7,6,6S555.8,344.5,552.5,344.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.7,368.5H303.5c-3.3,0-6-2.7-6-6s2.7-6,6-6l0,0h121.2c3.3,0,6,2.7,6,6S428,368.5,424.7,368.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/emptyChat.7b7df87bb4e248f0b34643884f771880.svg";
export { ForwardRef as ReactComponent };